var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"slider"},[_c('div',{staticClass:"owl-carousel owl-theme",attrs:{"id":"heroCarousel"}},_vm._l((_vm.slides),function(slide){return _c('div',{staticClass:"slide",style:({backgroundImage : 'url('+ slide.image +')'})})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }